import { Config } from '@flowwai-frontend/bps-officer-web/env-config'

import { PipelineCustomization } from '../types'

import { useUserAppConfigStore } from './stores/useUserAppConfigStore'

export interface PipelineCustomizationReturnType {
   isActivitiesEnabled: boolean
   isCallLogsEnabled: boolean
   isSendWhatsAppMessagesEnabled: boolean
   isShareableResourcesEnabled: boolean
   isTasksEnabled: boolean
   isRecordScoreEnabled: boolean

   setIsActivitiesEnabled: (isActivitiesEnabled: boolean) => void
   setIsCallLogsEnabled: (isCallLogsEnabled: boolean) => void
   setIsSendWhatsAppMessagesEnabled: (
      isSendWhatsAppMessagesEnabled: boolean
   ) => void
   setIsShareableResourcesEnabled: (
      isShareableResourcesEnabled: boolean
   ) => void
   setIsTasksEnabled: (isTasksEnabled: boolean) => void
   setIsRecordScoreEnabled: (isRecordScoreEnabled: boolean) => void
}

interface ReturnType {
   getPipelineCustomizations: (
      pipelineId: string
   ) => PipelineCustomizationReturnType
}

const useGetPipelineCustomizations = (): ReturnType => {
   const { permissions } = useUserAppConfigStore()

   const defaultPipelineCustomization: PipelineCustomization = {
      enableActivities: true,
      enableCalls: true,
      enableSendWhatsAppMessages: true,
      enableShareableResources: true,
      enableTasks: true,
      enableRecordScore: true
   }

   const getPipelineCustomizations = (
      pipelineId: string
   ): PipelineCustomizationReturnType => {
      const pipelineCustomizations =
         permissions?.getPipelineCustomization(pipelineId) ??
         defaultPipelineCustomization

      const isTasksEnabled =
         pipelineCustomizations.enableTasks &&
         Config.ENABLE_SUGGESTED_TASKS === 'true'

      const setIsActivitiesEnabled = (isActivitiesEnabled: boolean): void => {
         pipelineCustomizations.enableActivities = isActivitiesEnabled
      }

      const setIsCallLogsEnabled = (isCallLogsEnabled: boolean): void => {
         pipelineCustomizations.enableCalls = isCallLogsEnabled
      }

      const setIsSendWhatsAppMessagesEnabled = (
         isSendWhatsAppMessagesEnabled: boolean
      ): void => {
         pipelineCustomizations.enableSendWhatsAppMessages = isSendWhatsAppMessagesEnabled
      }

      const setIsShareableResourcesEnabled = (
         isShareableResourcesEnabled: boolean
      ): void => {
         pipelineCustomizations.enableShareableResources = isShareableResourcesEnabled
      }

      const setIsTasksEnabled = (isTasksEnabled: boolean): void => {
         pipelineCustomizations.enableTasks = isTasksEnabled
      }

      const setIsRecordScoreEnabled = (isRecordScoreEnabled: boolean): void => {
         pipelineCustomizations.enableRecordScore = isRecordScoreEnabled
      }

      return {
         isActivitiesEnabled: pipelineCustomizations.enableActivities,
         isCallLogsEnabled: pipelineCustomizations.enableCalls,
         isSendWhatsAppMessagesEnabled:
            pipelineCustomizations.enableSendWhatsAppMessages,
         isShareableResourcesEnabled:
            pipelineCustomizations.enableShareableResources,
         isTasksEnabled,
         isRecordScoreEnabled: pipelineCustomizations.enableRecordScore,

         setIsActivitiesEnabled,
         setIsCallLogsEnabled,
         setIsSendWhatsAppMessagesEnabled,
         setIsShareableResourcesEnabled,
         setIsTasksEnabled,
         setIsRecordScoreEnabled
      }
   }

   return {
      getPipelineCustomizations
   }
}

export default useGetPipelineCustomizations
